import { createPortal } from "react-dom";
import { toast, ToastContainer } from "react-toastify";
import { ModelWindowStyles } from "./ModelQRCode.styled";
import { useEffect } from "react";

export const ModelUpdateQRCode = ({ children, onClose, isOpen }) => {
  const modelAuth = document.getElementById("model-auth");

  useEffect(() => {
    const closeESCButton = (evt) => {
      if (evt.code === "Escape") {
        toast.error("You cannot close modal");
      }
    };

    document.body.style.overflowY = "hidden";
    document.addEventListener("keydown", closeESCButton);
    return () => {
      document.body.style.overflowY = "scroll";
      document.removeEventListener("keydown", closeESCButton);
    };
  }, [onClose, isOpen]);

  // add animation shack it, when trying close
  // add more keyboards

  if (!modelAuth) return null; // захист, якщо елементу немає

  return createPortal(
    <>
      <ModelWindowStyles
        onClick={(e) => {
          if (e.target === e.currentTarget) {
            toast.error("You cannot close modal");
          }
        }}
        
      >
        {children}
      </ModelWindowStyles>

      <ToastContainer />
    </>,
    modelAuth
  );
};
